<template>
  <div class="drawer">
    <div class="drawer-container">
      <div class="drawer-content with-footer">
        <el-form
          ref="bargainForm"
          :model="bargain"
          label-width="90px"
          size="small"
          class="box"
        >
          <fieldset class="mgb15">
            <legend>
              {{ $t("text.baseInfo") }}
            </legend>
            <el-row>
              <el-col :span="8">
                <el-form-item
                  :label="$t('bargain.serialNo')"
                  :prop="'serialNo'"
                  :rules="[
                    {
                      required: true,
                      validator: validateSerialNo,
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-input
                    size="small"
                    v-model.trim="bargain.serialNo"
                    :placeholder="$t('prompt.alphabetNumberLine')"
                    clearable
                    :disabled="!canEditSerialNo()"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$t('menu.shops')"
                  :prop="'shopId'"
                  :rules="[
                    {
                      required: true,
                      message: $t('rules.required', [$t('menu.shops')]),
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-select
                    v-model="bargain.shopId"
                    clearable
                    filterable
                    :disabled="Permit.createOrderFixShopDF()"
                    @change="selectShop"
                  >
                    <el-option
                      v-for="shop in shops"
                      :key="shop.id"
                      :label="shop.name"
                      :value="shop.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('shop.iossNum')" :prop="'iossNum'">
                  <el-input
                    size="small"
                    v-model.trim="bargain.iossNum"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
              <el-col
                v-if="bargain.payAmount == 0 && financeVerifyInfoDF()"
                :span="12"
              >
                <el-form-item
                  :label="$t('bargain.settleType')"
                  :prop="'amount'"
                >
                  <el-radio-group v-model="bargain.settleType">
                    <el-radio
                      v-for="settleType of settleTypes"
                      :key="settleType"
                      :label="settleType"
                      >{{ $t("settleTypes." + settleType) }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </fieldset>
          <fieldset class="mgb15" v-if="canEditBargainAddress()">
            <legend>
              {{ $t("customer.addressInfo") }}
              <el-tag
                size="mini"
                @click="addressAnalysis('aliexpress')"
                style="margin-bottom: 0px"
                class="float-right"
                >速卖通地址解析</el-tag
              >
              <el-tag
                size="mini"
                @click="addressAnalysis('amazon')"
                style="margin-bottom: 0px"
                class="float-right"
                >亚马逊地址解析</el-tag
              >
            </legend>
            <el-row>
              <el-col :span="8">
                <el-form-item
                  :label="$t('user.name')"
                  :prop="'customerName'"
                  :rules="[
                    {
                      required: true,
                      message: $t('rules.required', [$t('user.name')]),
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-input v-model="bargain.customerName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$t('user.phone')"
                  :prop="'customerPhone'"
                  label-width="90px"
                  :rules="[
                    {
                      required: true,
                      message: $t('rules.required', [$t('user.name')]),
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-input v-model="bargain.customerPhone"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('customer.email2')">
                  <el-input
                    size="small"
                    v-model.trim="bargain.customerEmail"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('tenant.country')">
                  <el-select v-model="bargain.customerCountry" filterable>
                    <el-option
                      v-for="country in countries"
                      :key="country"
                      :label="$t('countries.' + country)"
                      :value="country"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$t('tenant.province')"
                  :prop="'customerProvince'"
                >
                  <el-input v-model="bargain.customerProvince"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$t('customer.customerProvinceCode')"
                  :prop="'customerProvinceCode'"
                >
                  <el-input v-model="bargain.customerProvinceCode"></el-input>
                </el-form-item>
              </el-col>
              
              <el-col :span="8">
                <el-form-item :label="$t('tenant.city')" :prop="'customerCity'">
                  <el-input v-model="bargain.customerCity"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="16">
                <el-form-item
                  :label="$t('tenant.address')"
                  :prop="'customerAddress'"
                >
                  <el-input v-model="bargain.customerAddress"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              
              <el-col :span="8">
                <el-form-item
                  :label="$t('customer.zipcode')"
                  :prop="'customerZipcode'"
                >
                  <el-input v-model="bargain.customerZipcode"></el-input>
                </el-form-item>
              </el-col>
               <el-col :span="16">
                <el-form-item
                  :label="$t('bargain.deliveryRemark')"
                  :prop="'deliveryRemark'"
                >
                  <el-input v-model="bargain.deliveryRemark" />
                </el-form-item>
              </el-col>
            </el-row>
          </fieldset>
          <fieldset class="mgb15">
            <legend>
              {{ $t("text.remark") }}
              <small class="orange">
                ({{ $t("bargain.remarkExplain") }})
              </small>
            </legend>
            <el-input v-model="bargain.remark" type="textarea" :rows="2" />
          </fieldset>
        </el-form>
      </div>
    </div>
    <div class="drawer-footer">
      <el-button
        type="primary"
        size="small"
        plain
        :loading="saveDoing"
        @click="saveSubmit"
        >{{ $t("text.submit") }}</el-button
      >
    </div>

    <el-dialog
      :append-to-body="true"
      :title="$t('action.addressAnalysis')"
      :close-on-click-modal="false"
      :visible.sync="addressAnalysisDF"
      width="30%"
    >
      <el-form label-width="80px">
        <el-input
          size="small"
          v-model.trim="addressAnalysisObj.address"
          type="textarea"
          :rows="4"
        ></el-input>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="addressAnalysisDoing"
          size="small"
          @click="addressAnalysisSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addressAnalysisDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import { page } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import Bargain from "@/api/bargain.js";
import Shop from "@/api/shop.js";
import Order from "@/api/order.js";
import { settleTypes, countries, countriesCN } from "@/utils/enums.js";

export default {
  props: {
    id: Number,
  },
  mixins: [page],
  components: {},
  data() {
    var validateSerialNo = (rule, value, callback) => {
      const self = this;
      if (value === null || value === "") {
        callback(
          new Error(self.$t("rules.required", [this.$t("bargain.serialNo")]))
        );
        return;
      }
      // if (!Util.regexAlphabetNumberLine(value)) {
      //   callback(new Error(self.$t("prompt.regexAlphabetNumberLine")));
      //   return;
      // }

      Bargain.findBySerialNo({ serialNo: value }).then(function (res) {
        // console.log("====", res.data);
        if (res.data.code === 200 && res.data.entity.id !== self.bargain.id) {
          callback(
            new Error(self.$t("rules.exist", [self.$t("bargain.serialNo")]))
          );
        } else {
          Order.findBySerialNo({ serialNo: value }).then(function (res) {
            if (
              res.data.code === 200 &&
              !self.bargain.orders.map((o) => o.serialNo).includes(value)
            ) {
              callback(
                new Error(self.$t("rules.exist", [self.$t("order.serialNo")]))
              );
            } else {
              callback();
            }
          });
        }
      });
    };
    return {
      Util: Util,
      validateSerialNo: validateSerialNo,
      settleTypes: settleTypes,
      countries: countries,
      bargain: {},
      shops: [],
      saveDoing: false,
      //
      addressAnalysisType: null,
      addressAnalysisDF: false,
      countriesCN: countriesCN,
      addressAnalysisDoing: false,
      addressAnalysisObj: {
        address: null,
      },
    };
  },

  computed: {},
  created() {
    const self = this;
    self.loadingStart();
    axios.all([Bargain.findById(self.id), Shop.findByTenantId()]).then(
      axios.spread(function (bargain, shops) {
        if (bargain.data.code === 200) {
          self.bargain = bargain.data.entity;
        } else {
          self.sysError();
        }
        if (shops.status === 200) {
          self.shops = shops.data;
        } else {
          self.sysError();
        }
        self.loadingEnd();
      })
    );
  },
  methods: {
    selectShop() {
      const self = this;
      if (self.bargain.shopId != null && self.bargain.shopId != "") {
        const obj = self.shops.find((s) => s.id == self.bargain.shopId);
        if (obj != null) {
          self.bargain.iossNum = obj.iossNum;
        }
      }
    },
    addressAnalysis(type) {
      this.addressAnalysisType = type;
      this.addressAnalysisObj.address = null;
      this.addressAnalysisDF = true;
    },
    addressAnalysisSubmit() {
      if (
        this.addressAnalysisObj.address == null ||
        this.addressAnalysisObj.address == ""
      ) {
        this.$message({
          dangerouslyUseHTMLString: true,
          message: "先填写地址信息",
          type: "warning",
        });
        return;
      }
      this.addressAnalysisDoing = true;
      if (this.addressAnalysisType == "aliexpress") {
        let aliexpressArr = this.addressAnalysisObj.address.split(",");
        if (aliexpressArr.length != 5) {
          this.$message({
            dangerouslyUseHTMLString: true,
            message:
              "按照速卖通地址合适输入<br/><br/> 地址,城市,省份,国家,邮编",
            type: "warning",
          });
          this.addressAnalysisDoing = false;
          return;
        }
        //
        this.bargain.customerAddress = aliexpressArr[0].trim();
        this.bargain.customerCity = aliexpressArr[1].trim();
        this.bargain.customerProvince = aliexpressArr[2].trim();
        this.bargain.customerZipcode = aliexpressArr[4].trim();
        for (const country in countriesCN) {
          if (
            countriesCN[country].substring(0, aliexpressArr[3].trim().length) ==
            aliexpressArr[3].trim()
          ) {
            this.bargain.customerCountry = country;
          }
        }
        this.addressAnalysisDoing = false;
        this.addressAnalysisDF = false;
        return;
      }
      if (this.addressAnalysisType == "amazon") {
        let amazonArr = this.addressAnalysisObj.address.split("\n");
        if (
          amazonArr.length != 4 ||
          (amazonArr.length == 4 && amazonArr[2].split(",").length != 2) ||
          (amazonArr.length == 4 &&
            amazonArr[2].split(",").length == 2 &&
            amazonArr[2].split(",")[1].trim().split(" ").length != 2)
        ) {
          this.$message({
            dangerouslyUseHTMLString: true,
            message:
              "按照亚马逊地址合适输入<br/> <br/> 姓名<br/>地址<br/>城市,省份 邮编<br/>国家",
            type: "warning",
          });
          this.addressAnalysisDoing = false;
          return;
        }
        //
        this.bargain.customerName = amazonArr[0].trim();
        this.bargain.customerAddress = amazonArr[1].trim();
        let cityPro = amazonArr[2].split(",");
        this.bargain.customerCity = cityPro[0].trim();
        let proZip = cityPro[1].trim().split(" ");
        this.bargain.customerProvince = proZip[0].trim();
        this.bargain.customerZipcode = proZip[1].trim();
        for (const country in countriesCN) {
          if (
            countriesCN[country].substring(
              countriesCN[country].length - amazonArr[3].trim().length - 1,
              countriesCN[country].length - 1
            ) == amazonArr[3].trim()
          ) {
            this.bargain.customerCountry = country;
          }
        }
        this.addressAnalysisDoing = false;
        this.addressAnalysisDF = false;
        return;
      }
    },
    //编辑地址
    canEditBargainAddress() {
      if (
        this.bargain &&
        this.bargain.orders &&
        this.bargain.orders.length !== 0
      ) {
        const workflowStates = this.bargain.orders.map((r) => r.workflowState);
        const workflowStatesSet = [...new Set(workflowStates)];
        if (
          workflowStatesSet.length == 1 &&
          workflowStatesSet[0] == "finished"
        ) {
          return false;
        }
        return true;
      } else {
        return true;
      }
    },
    canEditSerialNo() {
      if (
        this.bargain &&
        this.bargain.orders &&
        this.bargain.orders.length !== 0
      ) {
        const ordersWorkflowStates = this.bargain.orders.map(
          (o) => o.workflowState
        );
        for (const sta of ordersWorkflowStates) {
          if (
            [
              "forout",
              "shipped",
              "partially",
              "finished",
              "canceled",
              "returned",
            ].includes(sta)
          ) {
            return false;
          }
        }
      }

      return true;
    },
    // -----财务审核权限
    financeVerifyInfoDF() {
      const financeVerifyInfoDF =
        this.Permit.currentTenant().config.financeVerifyStrict === false ||
        (this.Permit.currentTenant().config.financeVerifyStrict &&
          (this.bargain.financeAudit == null ||
            (this.bargain.financeAudit != null &&
              this.bargain.financeAudit.dealType === "reject")));
      return financeVerifyInfoDF;
    },

    saveSubmit() {
      const self = this;
      self.$refs.bargainForm.validate((valid) => {
        if (valid) {
          self.saveDoing = true;
          if (self.shops.find((s) => s.id == self.bargain.shopId) != null) {
            self.bargain.shopName = self.shops.find(
              (s) => s.id == self.bargain.shopId
            ).name;
          }
          Bargain.update(self.bargain.id, self.bargain).then(function (res) {
            self.saveDoing = false;
            if (res.status === 200) {
              // self.$message({
              //   message: self.$t("prompt.editSuccess"),
              //   type: "success",
              // });
              self.updateCustomerInfo();
              // self.$emit("updateInfo", self.bargain);
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    updateCustomerInfo() {
      const self = this;
      const Obj = {
        uuid: self.bargain.uuid,
        customerName: self.bargain.customerName,
        customerPhone: self.bargain.customerPhone,
        customerCountry: self.bargain.customerCountry,
        customerProvince: self.bargain.customerProvince,
        customerProvinceCode: self.bargain.customerProvinceCode,
        customerCity: self.bargain.customerCity,
        customerAddress: self.bargain.customerAddress,
        deliveryRemark: self.bargain.deliveryRemark,
        customerZipcode: self.bargain.customerZipcode,
        customerEmail: self.bargain.customerEmail,
      };
      Bargain.updateCustomerInfo(Obj).then(function (res) {
        self.saveDoing = false;
        if (res.status === 200) {
          if (res.data.type == "success") {
            self.$message({
              message: res.data.message,
              type: "success",
            });
            self.$emit("updateInfo", self.bargain);
          } else {
            self.$message({
              message: res.data.message,
              type: "error",
            });
          }
          // self.$message({
          //   message: self.$t("prompt.editSuccess"),
          //   type: "success",
          // });
        } else {
          self.sysError();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>